const blockedRoutes = [ "/auth/register"];

export default defineNuxtRouteMiddleware((to) => {
  if (blockedRoutes.includes(to.path)) {
    return navigateTo("/");
  }
})